<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-card class="bCardGlobal">
        <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span class="fa fa-address-book"></span>
            <span>Reporte</span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>Rep_Usuarios_sis</div>
          </b-col>
        </b-row>

        <div class="divSubtitulo">
          <p class="textoSubtitulo" style="font-size: 18px;">Usuarios de sistema</p>
        </div><br>


      <b-row>
        <b-col>
          <b-row class="mt-3">


          </b-row>
          <b-row align-v="center" align-h="end">

          </b-row>

          <b-row>
            <b-col></b-col>
            <b-col class="text-right">
              <span>
                <download-excel
                    v-if="datosTabla.length > 0 && $localStorageService.can('Rep_lis_usuario_sistema')"
                    class="btn btn-outline-success mr-4"
                    :data="datosTabla"
                    :fields="fieldsExcel"

                    worksheet="My Worksheet"
                    :name="'ReporteUsuario'+$formatoFecha(new Date())+'.xls'"
                >
                  Generar Excel
                  <em class="fa fa-file-excel-o"></em>
                </download-excel>
                </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">

          </b-table>

          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No se encontraron datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
      </b-card>

    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  components: {Header},
  name: "ReporteF",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    paginaActual: 1,
    loader: false,
    buscado: false,
    datosTabla: [],
    fields: [
      {key: "nombreUsuario", label: "Nombre usuario", sortable: true},
      {key: "nombreCompleto", label: "Nombre colaborador", sortable: true},
      {key: "fechaAlta", label: "Fecha alta", sortable: true},
      {key: "personaAlta", label: "Persona que da de alta", sortable: true},
      {key: "fechaModificacion", label: "Fecha Modificación", sortable: true},
      {key: "personaMod", label: "Persona modificacion", sortable: true},
      {key: "usuarioActivo", label: "Usuario activo", sortable: true},
      {key: "empleadoActivo", label: "Colaborador activo", sortable: true},
      {key: "clinicasActivas", label: "Clinicas activas", sortable: true},
      {key: "clinicasInactivas", label: "Clinicas inactivas", sortable: true},
    ],
    fieldsExcel:{
      "Nombre Usuario" : "nombreUsuario",
      "Nombre colaborador" : "nombreCompleto",
      "Fecha alta" : "fechaAlta",
      "Persona que da de alta" : "personaAlta",
      "Fecha modificación" : "fechaModificacion",
      "Persona modificación" : "personaMod",
      "Usuario activo" : "usuarioActivo",
      "Colaborador activo" : "empleadoActivo",
      "Clinicas activas" : "clinicasActivas",
      "Clinicas inactivas" : "clinicasInactivas",
    }
  }),
  validations: {
  },

  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerDatos();
  },
  methods: {
    obtenerDatos(){
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'reportes/Obtener_Reporte').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it);

              })
              this.datosTabla = respuesta.data.data;
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },

  }

}
</script>

<style scoped>

</style>
